// import { useContext } from "react";
// import RbsContext from "src/utils/RoleBasedSecurity/RbsContext";
import jwt_decode from "jwt-decode";
import { getSession } from "src/utils/RoleBasedSecurity/Session";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import FEATURE_FLAGS from "src/utils/constants/featureFlags";

const useIsImpersonated = () => {
  // SSO_SERVICE/userinfo returns false for impersonated user, need to decode token instead
  // const rbsContext = useContext(RbsContext);
  // const isImpersonated = rbsContext.userInfo.isImpersonated();

  if (!useFeatureIsOn(FEATURE_FLAGS.IMPERSONATED_USER_DETECTION)) {
    return false;
  }

  const session = getSession();
  const isImpersonated = !!jwt_decode(session.getAccessToken())?.impersonator;

  return isImpersonated;
};

export default useIsImpersonated;
